<template lang="html">
  <div class="">
    <v-snackbar
      :timeout="vTimeout"
      v-model="snackbar"
      bottom
    >
      {{ vMessage }}
      <v-btn
        :color="vContext"
        text
        @click.native="snackbar = false">{{ vCloseButtonText }}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
const DEFAULT_TIMEOUT = 4000
const DEFAULT_MESSAGE = 'Hey!'
const DEFAULT_CONTEXT = '#fff'
const DEFAULT_CLOSE_BUTTON_TEXT = 'Close'

export default {
  props: {
    message: {
      type: String,
      default: DEFAULT_MESSAGE
    },
    timeout: {
      type: Number,
      default: DEFAULT_TIMEOUT
    },
    context: {
      type: String,
      default: DEFAULT_CONTEXT
    },
    closeButtonText: {
      type: String,
      default: DEFAULT_CLOSE_BUTTON_TEXT
    }
  },
  data () {
    return {
      snackbar: false,
      vMessage: DEFAULT_MESSAGE,
      vTimeout: DEFAULT_TIMEOUT,
      vContext: DEFAULT_CONTEXT,
      vCloseButtonText: DEFAULT_CLOSE_BUTTON_TEXT
    }
  },
  methods: {
    open (openMessage, options = {}) {
      this.vMessage = openMessage || this.message || DEFAULT_MESSAGE
      this.vTimeout = options.timeout || this.timeout || DEFAULT_TIMEOUT
      this.vContext = options.context || this.context || DEFAULT_CONTEXT
      this.vCloseButtonText = options.closeButtonText || this.closeButtonText || DEFAULT_CLOSE_BUTTON_TEXT

      // enable the snackbar
      this.snackbar = true
    },
    close () {
      this.snackbar = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .GmeliusSnackBar {
    i {
      margin-right: 10px
    }
  }
</style>
